// Costanti condivise per i turni (Mattina / Pomeriggio / Notte).
export const SHIFT_TYPES = ["mattina", "pomeriggio", "notte"];
export const SHIFT_LABELS = { mattina: "Mattina", pomeriggio: "Pomeriggio", notte: "Notte" };
export const SHIFT_SHORT = { mattina: "M", pomeriggio: "P", notte: "N" };
export const SHIFT_COLORS = { mattina: "#f59e0b", pomeriggio: "#0ea5e9", notte: "#6366f1" };
export const DEFAULT_SHIFT_HOURS = {
  mattina: { start: "06:00", end: "14:00" },
  pomeriggio: { start: "14:00", end: "22:00" },
  notte: { start: "22:00", end: "06:00" },
};
